
import Modal from "react-bootstrap/Modal";

export default function AppModal({
  show,
  title,
  onClose,
}) {
  return (
    
    <Modal
      show={show}
      onHide={onClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <input
          className="form-control mb-3"
          placeholder="Name"
        />

        <input
          className="form-control"
          placeholder="Price"
        />

      </Modal.Body>
    </Modal>
  );
}

